import { Injectable, inject } from "@angular/core";
import { OKTA_AUTH } from "@okta/okta-angular";
import { OktaAuth } from "@okta/okta-auth-js";
import { IdleService } from "./idle.service";
import { Overlay, OverlayRef } from "@angular/cdk/overlay";
import { ComponentPortal } from "@angular/cdk/portal";
import { ReauthOverlayComponent } from "./reauth-overlay.component";

@Injectable({ providedIn: "root" })
export class SessionMonitorService {
  private okta = inject<OktaAuth>(OKTA_AUTH);
  private idle = inject(IdleService);
  private overlay = inject(Overlay);
  private overlayRef?: OverlayRef;
  private isShown = false;

  init() {
    this.idle.onIdle$.subscribe(() => this.showPrompt());
    this.okta.tokenManager.on("expired", () => this.showPrompt());
    window.addEventListener("reauth-click", () => this.reauthenticate());
  }

  private showPrompt() {
    if (this.isShown) return;
    this.isShown = true;
    this.overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: "reauth-backdrop",
      panelClass: "reauth-panel",
      scrollStrategy: this.overlay.scrollStrategies.block(),
      positionStrategy: this.overlay
        .position()
        .global()
        .centerHorizontally()
        .centerVertically(),
    });
    this.overlayRef.attach(new ComponentPortal(ReauthOverlayComponent));
  }

  private async reauthenticate() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = undefined;
    }
    this.isShown = false;
    // await this.okta.signInWithRedirect({ prompt: 'login' } as any);
    await this.okta.signInWithRedirect(); // no prompt: 'login'
  }
}
